import {Component, ElementRef, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {AccountService, AppConfig, Configuration, RestService} from '../../../shared/shared.module';

declare let cackle_widget: any[];

@Component({
  selector: 'app-blog-pages',
  templateUrl: './blog-pages.component.html',
  styleUrls: ['./blog-pages.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class BlogPagesComponent implements OnInit {
  public myTemplate: any = '';
  public Config: Configuration;
  isLogged: boolean;
  SsoAuth: string;
  constructor(
    private restService: RestService,
    private accountService: AccountService
  ) {
    const arrPath = window.location.pathname.split('/');
    const page = arrPath[arrPath.length - 1];
    const type = arrPath[arrPath.length - 2] === 'blog' ? 'blogs' : 'instructions';
    if (type && page) {
      this.restService.urlGet<string>('/assets/Documents/' + type + '/' + page + '.html', { responseType: 'text' }, true)
        .then(data => {
          this.myTemplate = data;
        });
    }

  }

  ngOnInit() {
    this.Config = AppConfig.config;
    this.accountService.isAuthenticated().then(result => {
      this.isLogged = (result.isLoggedIn && !result.isAnonymous);
      this.SsoAuth = result.SsoAuth;

      if (this.Config.cackleOn) {
        this.cackle_ajax_init();
      }
    });
  }

  /**
   * запуск системы комментариев
   * @param idRecipe
   */
  cackle_ajax_init() {
    cackle_widget = [];
    cackle_widget.push({
      widget: 'Comment',
      id: this.Config.cackleId,
      ssoAuth: this.SsoAuth,
      providers: this.isLogged ? this.Config.cackleProviders : ' ',
      ssoPrimary: !this.isLogged,
      ratingOff: this.Config.cackleRatingOff,
      sort: this.Config.cackleSort,
      size: this.Config.cackleSize,
      replies: this.Config.cackleReplies,
      level: this.Config.cackleLevel,
      chanWithoutParams: true
    });
    (function() {
      const mc = document.createElement('script');
      mc.type = 'text/javascript';
      mc.async = true;
      mc.src = ('https:' == document.location.protocol ? 'https' : 'http') + '://cackle.me/widget.js';
      const s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(mc, s.nextSibling);
    })();
  }

}



// WEBPACK FOOTER //
// ./src/app/landing/info/blog-pages/blog-pages.component.ts